<!-- FOOTER CERTITOOL WEB -->
<footer class="main-footer">
  <div class="container">
    <p class="copyright">&copy; {{ currentYear }} CertiTool Web · by certicámara. · Versión {{ appVersion }}</p>
  </div>
</footer>
